// extracted by mini-css-extract-plugin
export default {"inputWord":"input-word_inputWord__7UTwJ"};